<mat-card>
  <mat-card-header>
    @if (!gridStore.changes) {
    <mat-card-title>Assignments</mat-card-title>
    }
    @if (gridStore.changes) {
    <mat-card-title><i>Assignments*</i></mat-card-title>
    }
    <span class="spacer"></span>
    <div class="header-actions">
      <button (click)="openNewAssignmentDialog()" class="button-margin-right" mat-flat-button color="primary">
        <mat-icon fontIcon="fa-plus" fontSet="fas"></mat-icon>
        Add Assignment
      </button>
      <button (click)="undo()" [disabled]="pristine" class="button-margin-right" color="warn" mat-flat-button>
        <mat-icon fontIcon="fa-undo" fontSet="fas"></mat-icon>
        Discard Changes
      </button>
      <button (click)="commit()" [disabled]="pristine" color="accent" mat-flat-button>
        <mat-icon fontIcon="fa-save" fontSet="fas"></mat-icon>
        Save Changes
      </button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="grid-container">
      <app-grid (gridEvents)="onEvent($event)" [columns]="columns" [filter]="true" [showContextMenu]="true"
        [showDirty]="true" [showRemoveRowInContextMenu]="true" [store]="gridStore" [width]="'100%'"></app-grid>
    </div>
    <mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
      [pageIndex]="gridStore.currentPage - 1" [pageSizeOptions]="pageSizeOptions" [pageSize]="gridStore.pageSize"
      hidePageSize="false" showFirstLastButtons="true">
    </mat-paginator>
  </mat-card-content>
</mat-card>